export default __webpack_public_path__ + "media/zurb/img/development-process/sass_variables-94667674b7d1af95f9b08671a59369cd.png";